import queryString from 'query-string'
import H from 'history'
import {
    isFeatureEnabled,
    toFeatureState,
} from '@west-australian-newspapers/etrigan-feature-toggles-client'
import { PageType, Store } from '@news-mono/web-common'
import { TheNightlySection } from '@news-mono/common'
import { layout } from '../../App.routing'

const DEFAULT_MAX_ROWS = 7

export const getCommonwealthGamesMedalTallyWidgetRoute = (
    location: H.Location,
    store: Store,
): PageType<TheNightlySection> | null => {
    const featureState = toFeatureState(store.getState().toggles)
    if (!isFeatureEnabled(featureState, 'commonwealth-games-widgets', false)) {
        return null
    }

    const match = location.pathname
        .replace(/\/$/, '')
        .match(/\/sport\/commonwealth-games\/widgets\/([\w-]+)/)
    if (!match) return null

    const queryParams = queryString.parse(location.search)
    const colorMode = queryParams.colorMode === 'dark' ? 'dark' : 'light'
    const maxParam =
        typeof queryParams.max === 'string' ? queryParams.max : undefined
    const parsedMax = maxParam ? Number.parseInt(maxParam, 10) : Number.NaN
    const maxRows =
        Number.isInteger(parsedMax) && parsedMax > 0
            ? parsedMax
            : DEFAULT_MAX_ROWS
    const includeTotal = queryParams.includeTotal === 'false' ? false : true

    const size =
        queryParams.size === 'default' || queryParams.size === 'small'
            ? queryParams.size
            : undefined

    const widgetComponents = {
        'medal-tally': {
            type: 'commonwealth-games-medal-tally-widget',
            props: {
                maxRows,
                refreshIntervalSeconds: 60,
                colorMode,
                sortable: false,
                size: size ?? 'small',
                includeTotal,
                widgetState: 'results',
            },
        },
    } as const

    const widgetName = match[1] as keyof typeof widgetComponents
    const widgetConfig = widgetComponents[widgetName]
    if (!widgetConfig) return null

    const heading = 'Medal Tally | Commonwealth Games'
    return {
        kind: 'page',
        heading,
        hideHeading: true,
        pageType: 'simple-publication',
        section: 'default',
        adTargeting: {
            pageId: 'commonwealth-games-medal-tally-widget',
            adUnitPath: '/disable-ads',
            ssAdUnits: [],
            topics: [],
        },
        pageMeta: {
            title: heading,
            description:
                'Latest Commonwealth Games medal tally with country rankings and total medals on The Nightly.',
            meta: [
                {
                    'http-equiv': 'content-security-policy',
                    content: `frame-ancestors 'self'`,
                },
            ],
        },
        additionalPageProperties: {
            isWidget: true,
            widgetColorMode: colorMode,
        },
        compositions: [
            layout.composition({
                type: 'box',
                props: {
                    backgroundColor:
                        colorMode === 'dark' ? '#171717' : undefined,
                },
                contentAreas: {
                    main: [layout.component(widgetConfig)],
                },
            }),
        ],
    }
}
